import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import * as selectors from '@internalStore/style_guide/selectors';

import './sub_nav.scss';
import './sub_nav_style_guide.scss';

class SubNav extends Component {
  constructor(props) {
    super(props);

    this.renderMenu = this.renderMenu.bind(this);
    this.renderNewSideBar = this.renderNewSideBar.bind(this);
    this.renderSideBar = this.renderSideBar.bind(this);
  }

  renderMenu() {
    const { menuClassName, menu } = this.props;

    return menu && <div className={classnames('sub-nav__menu', menuClassName)}>{menu}</div>;
  }

  renderSideBar() {
    const { containerClassName, header, headerClassName } = this.props;
    return (
      <div className={classnames('sub-nav__sidebar', containerClassName)}>
        {header && <div className={classnames('sub-nav__header', headerClassName)}>{header}</div>}

        {this.renderMenu()}
      </div>
    );
  }

  renderNewSideBar() {
    const { containerClassName, header, headerClassName } = this.props;
    return (
      <div className={classnames('sub-nav__sidebar', containerClassName)}>
        {header && (
          <div className={classnames('sub-nav__header', headerClassName)}>
            <div className="sidebar-header-container sub-nav__header-alignment">{header}</div>
          </div>
        )}

        {this.renderMenu()}
      </div>
    );
  }

  render() {
    const { useNewStyleGuide } = this.props;
    return useNewStyleGuide ? this.renderNewSideBar() : this.renderSideBar();
  }
}

SubNav.propTypes = {
  containerClassName: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  headerClassName: PropTypes.string,
  menu: PropTypes.shape({}),
  menuClassName: PropTypes.string,
  useNewStyleGuide: PropTypes.bool,
};

const mapStateToProps = state => ({
  useNewStyleGuide: selectors.useNewStyleGuide(state),
});

export default connect(mapStateToProps)(SubNav);
